// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"3f11853b","376":"e6370b70"}[chunkId] + ".chunk.js";
};